import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { adminActions } from "../../../redux/actions";
import moment from "moment";

export default function CompletedOrders() {
  let user = JSON.parse(localStorage.getItem("user"));
  let teamId = JSON.parse(localStorage.getItem("teamId"));
  const company_id = user?.data?.groups[teamId]?.company_id;

  const completedOrders = useSelector((state) => state.admin.myCompleted);
  const singleCourierOrder = useSelector(
    (state) => state.admin.singleCourierOrder
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(adminActions.getMyCompletedCourierOrders(company_id));
  }, [dispatch, company_id]);

  // This is for getting the company settings
  useEffect(() => {
    if (company_id) {
      dispatch(adminActions.getACompanySettings(company_id));
    }
    // eslint-disable-next-line
  }, [company_id]);


  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  return (
    <div
      className="scroll-list"
      data-perfect-scrollbar
      data-suppress-scroll-x="true"
    >
      {/* <Rotate loading={true}/> */}
      {completedOrders && completedOrders.length === 0
        ? "No content found"
        : completedOrders?.map((completedOrder, i) => (
            <div
              key={i}
              className="card text-left mb-2"
              onClick={() =>
                dispatch(adminActions.getACourierOrder(completedOrder?.id))
              }
            >
              <div
                className={
                  completedOrder?.id === singleCourierOrder.id
                    ? "active-order card-body d-flex justify-content-between "
                    : "card-body d-flex justify-content-between "
                }
              >
                <div className="single-order">
                  <h5>
                    Order <span>#{completedOrder?.order?.id}</span>
                  </h5>
                  <p className="mb-0">
                    <i className="nav-icon i-Clock" />{" "}
                    <span>
                      {moment(completedOrder?.order?.created_at).format("lll")}
                    </span>
                  </p>
                </div>
                <div>
                  <h4 className="font-weight-bold">
                    ₦{numberWithCommas(completedOrder?.order?.order_amount)}
                  </h4>
                </div>
              </div>
            </div>
          ))}
    </div>
  );
}
